import { defineComponent as _defineComponent } from 'vue'
import { resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  class: "q-pa-md",
  style: {"display":"flex","flex-direction":"row"}
}


export default /*#__PURE__*/_defineComponent({
  __name: 'UserGameStats',
  props: { pvpData: Array, pncData: Array },
  setup(__props) {

const props = __props



function getPlayCountAndWinRate(stats: any) {
  let playedCount = 0;
  let winCount = 0;
  for (const [key, value] of Object.entries(stats)) {
    if (key.includes("Played")) playedCount += value as number
    if (key.includes("Won")) winCount += value as number
  }
  return `${playedCount} | ${((winCount / playedCount)*100).toFixed(0)}%`
}

function getCountByFilterKey(filterKey: string, stats: any) {
  const finalStats: { [key: string]: any } = {}
  for (const [key, value] of Object.entries(stats)) {
    if (key.includes(filterKey)) finalStats[key] = value;
  }
  return getPlayCountAndWinRate(finalStats)
}

const columns: Array<any> = [
  { name: 'Opponent', label: 'Opponent', field: (t: any) => t.rowKey, align: 'left' },
  { name: 'Gems', label: 'Gems 💎', field: (data: any) => getCountByFilterKey("Gems", data.dict), align: 'left' },
  { name: 'Cash', label: 'Cash 💵', field: (data: any) => getCountByFilterKey("Cash", data.dict), align: 'left' },
  { name: 'All', label: 'All', field: (data: any) => getPlayCountAndWinRate(data.dict), align: 'left' }
]


return (_ctx: any,_cache: any) => {
  const _component_q_table = _resolveComponent("q-table")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_q_table, {
      title: "PVP",
      rows: props.pvpData,
      columns: columns,
      style: {"margin-right":"15px","flex":"1"},
      separator: "cell",
      "hide-bottom": true
    }, null, 8, ["rows"]),
    _createVNode(_component_q_table, {
      title: "PNC",
      rows: props.pncData,
      columns: columns,
      style: {"margin-left":"15px","flex":"1"},
      separator: "cell",
      "hide-bottom": true
    }, null, 8, ["rows"])
  ]))
}
}

})